/* eslint-disable react-refresh/only-export-components */
'use client';

import type { ReactNode } from 'react';
import { createContext, use, useCallback, useMemo, useState } from 'react';
type AuthModalView = 'signIn' | 'signUp';
type AuthModalContextType = {
  isOpen: boolean;
  view: AuthModalView;
  openModal: (view: AuthModalView) => void;
  closeModal: () => void;
};
const AuthModalContext = createContext<AuthModalContextType | undefined>(undefined);
export function AuthModalProvider({
  children
}: {
  children: ReactNode;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [view, setView] = useState<AuthModalView>('signIn');
  const openModal = useCallback((newView: AuthModalView) => {
    setView(newView);
    setIsOpen(true);
  }, []);
  const closeModal = useCallback(() => {
    setIsOpen(false);
  }, []);

  // Memoize the context value so it doesn't change each render
  const value = useMemo(() => ({
    isOpen,
    view,
    openModal,
    closeModal
  }), [isOpen, view, openModal, closeModal]);
  return <AuthModalContext value={value} data-sentry-element="AuthModalContext" data-sentry-component="AuthModalProvider" data-sentry-source-file="AuthModalContext.tsx">
      {children}
    </AuthModalContext>;
}
export function useAuthModal() {
  const ctx = use(AuthModalContext);
  if (!ctx) {
    throw new Error('useAuthModal must be used inside AuthModalProvider');
  }
  return ctx;
}